import { CookieRepositoryStrategy } from '@/core/storage/cookie.constants'
import { StorageStrategy } from '@/core/storage/storage.constants'

export const AuthConfig = {
  storageSetup: {
    key: 'token',
    storage: StorageStrategy.Cookie,
    config: CookieRepositoryStrategy.MeetingDoctors,
  },
} as const

export type AuthConfig = typeof AuthConfig
